var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconImportToolHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/import/hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.1984127,4.76190476 L7.93650794,4.76190476 L7.93650794,0.793650794 C7.93650794,0.357142857 7.57936508,8.8817842e-16 7.14285714,8.8817842e-16 L3.96825397,8.8817842e-16 C3.53174603,8.8817842e-16 3.17460317,0.357142857 3.17460317,0.793650794 L3.17460317,4.76190476 L1.91269841,4.76190476 C1.20634921,4.76190476 0.849206349,5.61904762 1.34920635,6.11904762 L4.99206349,9.76190476 C5.3015873,10.0714286 5.8015873,10.0714286 6.11111111,9.76190476 L9.75396825,6.11904762 C10.2539683,5.61904762 9.9047619,4.76190476 9.1984127,4.76190476 Z M0,12.6984127 C0,13.1349206 0.357142857,13.4920635 0.793650794,13.4920635 L10.3174603,13.4920635 C10.7539683,13.4920635 11.1111111,13.1349206 11.1111111,12.6984127 C11.1111111,12.2619048 10.7539683,11.9047619 10.3174603,11.9047619 L0.793650794,11.9047619 C0.357142857,11.9047619 0,12.2619048 0,12.6984127 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/import/hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/export-polygon",
    transform: "translate(4.444444, 3.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#5697B7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.444444, -3.333333)",
    id: "Fill"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportToolHover);
export default __webpack_public_path__ + "static/media/icon_import_tool_hover.8a19a7a373d5fef95db008435f4239fa.svg";
export { ForwardRef as ReactComponent };